import React from "react";
import { Account } from "../components/Account";
const AccountPage = () => {
  return (
    <div>
      <Account />
    </div>
  );
};

export default AccountPage;
